import React from 'react';
import { Props } from './renderContent';
import TextBox from '../TextBox/TextBox';

const Quote = ({ children, options }: Props) => React.createElement(TextBox, { options: [...options, "left"], children: `• ${children}` });

export default Quote;